export const maximize = (color = 'white', size = '30') => {
	const svg = `
    <svg width="${size}" height="${size}" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.6071 11.5H8.5L11.75 16.5M15.9286 19H21.5L19.1786 14" stroke="${color}"/>
    </svg>
`;

	return svg;
};
